// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['lv_LV']  = {
  "name": "lv_LV",
  "day": {
    "abbrev": [
      "Sv",
      "P ",
      "O ",
      "T ",
      "C ",
      "Pk",
      "S "
    ],
    "full": [
      "svētdiena",
      "pirmdiena",
      "otrdiena",
      "trešdiena",
      "ceturtdiena",
      "piektdiena",
      "sestdiena"
    ]
  },
  "month": {
    "abbrev": [
      "jan",
      "feb",
      "mar",
      "apr",
      "mai",
      "jūn",
      "jūl",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    "full": [
      "janvāris",
      "februāris",
      "marts",
      "aprīlis",
      "maijs",
      "jūnijs",
      "jūlijs",
      "augusts",
      "septembris",
      "oktobris",
      "novembris",
      "decembris"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%Y.%m.%d.",
  "time24": "%T",
  "dateTime": "%A, %Y. gada %e. %B, plkst. %H un %M",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

